export const DEFAULT_CONDITIONS_PLACEMENT = 'docked_bottom';
export const DEFAULT_CONDITIONS_IS_SHOWN = false;

// Redux stuff
export const REDUCER_KEY_PROJECT_ROUTE = 'projectRoute';
export const FETCH_PROJECT_ROUTE_DATA = 'rs/FETCH_PROJECT_ROUTE_DATA';
export const FETCH_PROJECT_ROUTE_DATA_SUCCESS = 'rs/FETCH_PROJECT_ROUTE_DATA_SUCCESS';
export const FETCH_PROJECT_ROUTE_DATA_FAIL = 'rs/FETCH_PROJECT_ROUTE_DATA_FAIL';
export const PROJECT_ROUTE_SET_ACTIVE_STEP = 'rs/PROJECT_ROUTE_SET_ACTIVE_STEP';
export const PROJECT_ROUTE_SET_IS_TRANSFER_FROM_REACTION = 'rs/PROJECT_ROUTE_SET_IS_TRANSFER_FROM_REACTION';
export const PROJECT_ROUTE_CONDITIONS_FETCH_STEP_DATA = 'rs/PROJECT_ROUTE_CONDITIONS_FETCH_STEP_DATA';
export const PROJECT_ROUTE_CONDITIONS_STEP_DATA_SUCCESS = 'rs/PROJECT_ROUTE_CONDITIONS_STEP_DATA_SUCCESS';
export const PROJECT_ROUTE_EXAMPLES_STEP_DATA_SUCCESS = 'rs/PROJECT_ROUTE_EXAMPLES_STEP_DATA_SUCCESS';
export const PROJECT_ROUTE_CONDITIONS_STEP_DATA_ERROR = 'rs/PROJECT_ROUTE_CONDITIONS_STEP_DATA_ERROR';
export const PROJECT_ROUTE_CONDITIONS_SET_PLACEMENT = 'rs/PROJECT_ROUTE_CONDITIONS_SET_PLACEMENT';
export const PROJECT_ROUTE_CONDITIONS_SET_IS_SHOWN = 'rs/PROJECT_ROUTE_CONDITIONS_SET_IS_SHOWN';
export const PROJECT_ROUTE_CONDITIONS_STEP_SELECTION_SAVED = 'rs/PROJECT_ROUTE_CONDITIONS_STEP_SELECTION_SAVED';
export const COPY_ROUTE_FAILURE = 'rs/COPY_ROUTE_FAILURE';
export const DELETE_STEPS = 'rs/DELETE_STEPS';
export const DELETE_STEPS_SUCCESS = 'rs/DELETE_STEPS_SUCCESS';
export const DELETE_STEPS_FAILURE = 'rs/DELETE_STEPS_FAILURE';
export const CLEAR_DELETED_ROUTE = 'rs/CLEAR_DELETED_ROUTE';

export const STEP_DATA_EXAMPLES_SEARCH_DEBOUNCE_DELAY = 2500;

export const projectRouteDataCacheKey = (projectId, routeId) => ['rs', 'projectRoute', String(projectId), String(routeId)];
